import Vue from "vue-ltur";
var LazyComponent = /** @class */ (function () {
    function LazyComponent(component, options) {
        var ComponentClass = Vue.extend(component);
        this.element = new ComponentClass(options);
    }
    /**
     * mount the component as child inside the mountPoint
     *
     * @param mountPoint
     */
    LazyComponent.prototype.mount = function (mountPoint) {
        if (mountPoint === void 0) { mountPoint = document.getElementById('modal-container'); }
        this.element.$mount();
        mountPoint.appendChild(this.element.$el);
    };
    /**
     * mount the component as the mountPoint. This will delete the mountPoint element and all children
     *
     * @param mountPoint
     */
    LazyComponent.prototype.mountAt = function (mountPoint) {
        if (mountPoint === void 0) { mountPoint = document.getElementById('modal-container'); }
        this.element.$mount(mountPoint);
    };
    LazyComponent.prototype.destroy = function () {
        this.unmount();
        this.element.$destroy();
    };
    LazyComponent.prototype.unmount = function () {
        this.element.$el.remove();
    };
    Object.defineProperty(LazyComponent.prototype, "component", {
        get: function () {
            return this.element;
        },
        enumerable: false,
        configurable: true
    });
    return LazyComponent;
}());
export default LazyComponent;
